import { render, staticRenderFns } from "./BCXMessengerUserSelectItem.vue?vue&type=template&id=df8e58c6&scoped=true"
import script from "./BCXMessengerUserSelectItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerUserSelectItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerUserSelectItem.vue?vue&type=style&index=0&id=df8e58c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8e58c6",
  null
  
)

export default component.exports